import React from "react";
import Header8 from "./../Common/Header8";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import Services1 from "./../Elements/Services1";
import About6 from "./../Elements/About6";
import Statistics1 from "./../Elements/Statistics1";
import Testimonials2 from "./../Elements/Testimonials2";

var bnrimg = require("../../images/banner/banner.jpg");

class Service2 extends React.Component {
  render() {
    return (
      <>
        <Header8 />
        <div className="page-content">
          <Banner
            title="Nous Rejoindre"
            pagename="Nous Rejoindre"
            bgimage={bnrimg}
          />{" "}
          {/* <Services1 /> */}
          <About6 bgcolor="bg-white" />
        </div>
        <Footer />
      </>
    );
  }
}

export default Service2;
